import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'
import { ListingResponse } from '~in-app/types/api.dto'

import { FeatureListQuery, Features } from './types'

export const fetchFeatureList = async (params?: { abortCtrl?: AbortController | AbortSignal, query?: FeatureListQuery }) => {
  return wretchClient
    .url('/admin/1.0/products/features')
    .query(params?.query || {})
    .get()
    .json<ListingResponse<Features>>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const fetchFeatureDetails = async (params: { id: string, abortCtrl?: AbortController | AbortSignal }) => {
  return wretchClient
    .url(`/admin/1.0/products/features/${params.id}`)
    .signal(params?.abortCtrl)
    .get()
    .json<[Features]>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const deleteFeatures = async (id: string) => {
  return wretchClient
    .url(`/admin/1.0/products/features/${id}`)
    .delete()
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const addFeatures = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/products/features`)
    .post([value])
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
export const updateFeatures = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/products/features`)
    .put([value])
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
